import { render, staticRenderFns } from "./cannotAccess.vue?vue&type=template&id=3e6b3be3&"
import script from "./cannotAccess.vue?vue&type=script&lang=js&"
export * from "./cannotAccess.vue?vue&type=script&lang=js&"
import style0 from "./cannotAccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports